"use client";
import React, { useRef, useState, useEffect } from "react";
import { Popover } from "antd";
import { useJobTrans } from "./../../jobTransProvider";
import Lottie from "lottie-web";

import styles from "./Translation.mobile.module.scss";

export default function Translation({ aiTranslate }) {
  const { transData, setTransData } = useJobTrans();
  const containerRef = useRef(null);
  const [open, setOpen] = useState(false);
  const translationRef = useRef(null);
  let timer = useRef(null);

  useEffect(() => {
    let animation = null;

    if (timer.current) {
      clearTimeout(timer.current);
    }
    timer.current = setTimeout(() => {
      animation = Lottie.loadAnimation({
        container: containerRef.current,
        renderer: "svg",
        loop: false,
        autoplay: false,
        animationData: require("images/jobDetail.json")
      });
      animation.play();
    }, 500);

    return () => {
      animation?.destroy();
      clearTimeout(timer.current);
    };
  }, [open]);

  useEffect(() => {
    if (!transData.isOriginal) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [transData.isOriginal]);

  if (transData.showButton) {
    const content = (
      <div className={styles.tips}>
        <div className={styles.tipsContent}>
          <div ref={containerRef} className={styles.svgBox}></div>
          {aiTranslate?.translateText}
        </div>
      </div>
    );
    return (
      <div className={styles.translation}>
        <div
          className={styles.transButton}
          onClick={() => {
            setTransData((state) => ({
              ...state,
              isOriginal: !state.isOriginal
            }));
          }}
          ref={translationRef}
        >
          <Popover
            trigger='click'
            placement='bottom'
            getPopupContainer={(node: HTMLElement) => node?.parentNode as any}
            align={{
              offset: [-12, 6]
            }}
            title={null}
            content={content}
            open={open}
            onOpenChange={(state) => open && setOpen(state)}
            overlayClassName={styles.overlayOriginalWrap}
          >
            <span className={styles.button}>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='18'
                height='18'
                viewBox='0 0 18 18'
                fill='none'
              >
                <path
                  d='M12.134 7.70487L12.1775 7.77969L15.5781 14.5809C15.6566 14.7362 15.6726 14.9157 15.6228 15.0824C15.573 15.2492 15.4612 15.3905 15.3104 15.4773C15.1595 15.5641 14.9811 15.5897 14.8119 15.549C14.6427 15.5082 14.4956 15.4042 14.4008 15.2583L14.3614 15.1889L13.5289 13.5246H9.6087L8.77692 15.1889C8.70247 15.3381 8.57577 15.4548 8.4209 15.5168C8.26604 15.5787 8.09382 15.5816 7.93697 15.5249L7.8642 15.4929C7.71523 15.4183 7.59879 15.2917 7.53699 15.137C7.47519 14.9823 7.47231 14.8103 7.5289 14.6536L7.56019 14.5809L10.9608 7.77969C11.014 7.67326 11.0941 7.58265 11.1933 7.5169C11.2925 7.45115 11.4071 7.41256 11.5259 7.40499C11.6446 7.39741 11.7632 7.42112 11.87 7.47375C11.9767 7.52637 12.0677 7.60606 12.134 7.70487ZM6.80866 1.96265C6.97512 1.96283 7.13574 2.02407 7.26008 2.13475C7.38443 2.24543 7.46386 2.39787 7.48333 2.56319L7.4881 2.64276V3.32288H10.8887C11.062 3.32307 11.2288 3.38945 11.3548 3.50845C11.4809 3.62745 11.5567 3.79009 11.5669 3.96314C11.577 4.13619 11.5207 4.30659 11.4095 4.43952C11.2982 4.57245 11.1404 4.65788 10.9683 4.67835L10.8887 4.68311H9.92155C9.53662 6.47503 8.77378 8.16418 7.68397 9.63776C7.78939 9.75815 7.89821 9.8758 8.01043 9.99142C8.13579 10.1212 8.20446 10.2955 8.20134 10.4759C8.19821 10.6563 8.12354 10.8281 7.99376 10.9535C7.86398 11.0788 7.68971 11.1475 7.5093 11.1444C7.32888 11.1412 7.1571 11.0666 7.03174 10.9368L6.80866 10.6987C5.73428 11.8703 4.45334 12.834 3.02993 13.5416C2.9499 13.5814 2.86283 13.605 2.77369 13.6111C2.68455 13.6172 2.59508 13.6056 2.51039 13.5772C2.42569 13.5487 2.34744 13.5038 2.2801 13.4451C2.21276 13.3863 2.15764 13.3149 2.11789 13.2349C2.07815 13.1549 2.05455 13.0678 2.04846 12.9787C2.04236 12.8895 2.05389 12.8 2.08237 12.7154C2.11085 12.6307 2.15574 12.5524 2.21446 12.4851C2.27319 12.4177 2.3446 12.3626 2.42463 12.3229C3.75575 11.6614 4.9472 10.75 5.93403 9.63844C5.32678 8.81803 4.81883 7.92859 4.42077 6.98871C4.35042 6.82258 4.34895 6.63531 4.41668 6.4681C4.4844 6.30088 4.61578 6.16742 4.78191 6.09708C4.94804 6.02673 5.13531 6.02526 5.30252 6.09298C5.46974 6.16071 5.6032 6.29209 5.67354 6.45822C5.98045 7.18352 6.36057 7.8756 6.80798 8.52373C7.61176 7.35988 8.19436 6.05796 8.52663 4.68311H2.72728C2.55399 4.68275 2.38737 4.61625 2.26145 4.4972C2.13553 4.37814 2.0598 4.21551 2.04974 4.04252C2.03967 3.86952 2.09601 3.6992 2.20727 3.56634C2.31853 3.43348 2.47631 3.34811 2.64838 3.32764L2.72728 3.32288H6.12786V2.64276C6.12786 2.46239 6.19952 2.28939 6.32706 2.16185C6.45461 2.0343 6.6276 1.96265 6.80798 1.96265H6.80866ZM11.5695 9.60444L10.2881 12.1644H12.8481L11.5688 9.60444H11.5695Z'
                  fill='#121212'
                />
                <path
                  d='M10.206 3.76703L10.0909 3.45616C11.0287 3.10915 11.7681 2.36978 12.1151 1.432L12.426 1.54703L12.1151 1.432L12.1786 1.26045L10.206 3.76703ZM10.206 3.76703L10.0909 3.45616L9.91939 3.51964L10.0493 3.8708L10.206 3.76703ZM12.7679 1.39059L13.1196 1.26045L13.1831 1.432C13.5301 2.36978 14.2695 3.10915 15.2073 3.45616L15.3788 3.51964C15.8156 3.68127 15.8156 4.29906 15.3788 4.46068L15.2073 4.52416C14.2695 4.87117 13.5301 5.61055 13.1831 6.54832L13.1196 6.71987C12.958 7.15666 12.3402 7.15666 12.1786 6.71987L12.1151 6.54832C11.7681 5.61055 11.0287 4.87117 10.0909 4.52416L9.91939 4.46068C9.4826 4.29906 9.4826 3.68127 9.91939 3.51964L12.7679 1.39059ZM12.7679 1.39059L13.1196 1.26045M12.7679 1.39059L13.1196 1.26045M13.1196 1.26045C12.958 0.823665 12.3402 0.823663 12.1786 1.26045L13.1196 1.26045ZM15.1183 4.22294L15.1185 4.22303L15.1468 4.14669L15.1185 4.22303C15.1184 4.223 15.1184 4.22297 15.1183 4.22294ZM12.8703 1.54776L12.8378 1.55977L12.8703 1.54776Z'
                  fill='#121212'
                  stroke='white'
                  strokeWidth='0.75'
                />
              </svg>
              <span>
                {transData.isOriginal ? aiTranslate?.translationText : aiTranslate?.originalText}
              </span>
            </span>
          </Popover>
        </div>
      </div>
    );
  }
  return null;
}
